import React from 'react';

import styles from 'components/common/ui/Tour/styles/Step.module.less';

const Step2Component = () => (
  <div className={styles.stepContainer}>
    <h3>We&apos;ll Help You Connect to Zoom to Get Started</h3>
    <p className={styles.stepCopy}>
      Don&apos;t have a Zoom account? We&apos;ll help you create one later for free.
    </p>
  </div>
);

export default {
  target: '#edit-page__add-entity-section__virtual-events',
  content: <Step2Component />,
  placement: 'top-start',
  disableBeacon: true,
  stepName: 'create_virtual_event_cta',
};



// WEBPACK FOOTER //
// ./src/components/manage/website/WalkthroughTour/StepCollections/VirtualEventsOnboardingEditPage/Step2.jsx